import { Component, OnInit } from '@angular/core';
import {SubscriptionsService} from '../../../services/subscriptions/subscriptions.service';

@Component({
  selector: 'kt-subscriptions-error',
  templateUrl: './subscriptions-error.component.html',
  styleUrls: ['./subscriptions-error.component.scss']
})
export class SubscriptionsErrorComponent implements OnInit {
  userDevice = null;

  constructor(
    private subscriptions: SubscriptionsService
  ) { }

  ngOnInit(): void {
    this.userDevice = this.subscriptions.userDevice;
  }

  toShop() {
    window.open('https://mindfield-shop.com/', '_blank')
  }
}
